import {Types} from "../actions/EquipmentNotesAction"

const initialState = {
    equipmentNotes: {},
    isTaskUpdated: false,
}

export const equipmentNotesReducer = (state = initialState, action) => {
    switch(action.type){
        case Types.SET_EQUIPMENT_NOTES:
            return {
                ...state,
                equipmentNotes: action.payload || state.equipmentNotes,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
}